import {useEffect, useMemo, useState} from 'react'
import {useSelector} from 'react-redux'
import {useEnhancedScroll} from 'hooks/useEnhancedScroll'
import {getOverlay} from 'modules/overlay/selectors'
import {
  getIsSearchBoxOpen,
  getSearchBoxAncestor
} from 'modules/searchBox/selectors'
import {SearchBoxAncestor} from 'modules/searchBox/types'

/**
 * This hook is used to manage the new top bar.
 * It provides a showDivider and showCompactHeader.
 * It also provides a scrollAnimationStarted state to manage the scroll animation.
 * It also provides a searchBoxIsOpen state to manage the search box.
 * It also provides a isCompactAvailable state to manage the compact header.
 */
export const useNewTopBar = () => {
  const activeAncestor = useSelector(getSearchBoxAncestor)
  const overlayState = useSelector(getOverlay)

  const isOverlayOpen = overlayState.length > 0

  const searchBoxIsOpen =
    useSelector(getIsSearchBoxOpen) && SearchBoxAncestor.Page === activeAncestor
  const {scrollYValue, directionY} = useEnhancedScroll(
    isOverlayOpen,
    isOverlayOpen
  )
  const [showDivider, setShowDivider] = useState(false)
  const [isCompactAvailable, setIsCompactAvailable] = useState(false)
  const [scrollAnimationStarted, setScrollAnimationStarted] = useState(false)

  useEffect(() => {
    setShowDivider(scrollYValue > 1)
    setIsCompactAvailable(scrollYValue > 70)
    setScrollAnimationStarted(true)
  }, [scrollYValue])

  const showCompactHeader = useMemo(() => {
    return (
      directionY === 'down' &&
      !searchBoxIsOpen &&
      scrollAnimationStarted &&
      isCompactAvailable
    )
  }, [directionY, searchBoxIsOpen, scrollAnimationStarted, isCompactAvailable])

  useEffect(() => {
    if (searchBoxIsOpen) {
      setScrollAnimationStarted(false)
    }
  }, [searchBoxIsOpen])

  return {
    showDivider,
    showCompactHeader
  }
}
